import { StateSchema } from 'app/config/storeConfig/types';
import { Invoice } from 'entities/Invoice';

export const getInvoiceData = (state: StateSchema): Nullable<Partial<Invoice>> => state.issueInvoiceModal.invoiceData;
